import React, { useCallback, useId } from "react";
import { useEditEntityMutation } from "@api/entity.api";
import { useEntity } from "@components/entity/useEntity";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { Switch } from "@design-system/Switch/Switch";
import { SectionHeader } from "@design-system/Section/Section";
import styles from "./KickAISettings.module.scss";

export const KickAISettings: React.FC = () => {
    const entity = useEntity();
    const editEntity = useEditEntityMutation(entity);
    const { error } = useToaster();
    const titleId = useId();

    const handleToggle = useCallback(
        (isActive: boolean) => {
            editEntity
                .mutateAsync({
                    allowAITrainingOnTheirData: isActive,
                })
                .catch(() => {
                    error("Failed to update AI training preference");
                });
        },
        [editEntity, error],
    );

    return (
        <section className="mb-5">
            <SectionHeader>
                <h4>Kick AI</h4>
            </SectionHeader>

            <div className={styles.container}>
                <div className={styles.row}>
                    <div className={styles.content}>
                        <span id={titleId} className={styles.title}>
                            Kick AI Program
                        </span>
                        <span className={styles.description}>
                            Improve your AI quality by sharing data from this
                            business with Kick. See{" "}
                            <a
                                href="https://kick.co/legal#ai-terms"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Kick AI Terms
                            </a>
                            .
                        </span>
                    </div>

                    <Switch
                        checked={entity.allowAITrainingOnTheirData}
                        onCheckedChange={handleToggle}
                        aria-labelledby={titleId}
                        loading={editEntity.isPending}
                        disabled={editEntity.isPending}
                    />
                </div>
            </div>
        </section>
    );
};
